import {Injectable} from '@angular/core';
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {GridService} from '../grid.service';


@Injectable()
export class AllGridsResolver implements Resolve<any> {
	constructor(
		private gridService: GridService
	) {}


	params: any = {};


	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
		// console.log('AllFilmsResolver called    #1');
		// let startResolve = Date.now();

		this.params = JSON.parse(JSON.stringify(route.params));

		let thePromise = new Promise((resolve, reject) => {
			// this.reviewerFilmService.getFilms()
			this.gridService.getGrids()
				.then((grids: any) => {

					// let endResolve = Date.now();
					// console.log('AllFilmsResolver called    #2, took ' + (endResolve - startResolve) + ' msec' );


					let allGridsInfo = {
						allGrids: grids.allGrids.grids,
						params: this.params
					};
					resolve(allGridsInfo);
				})
				.catch((err) => {
					return reject(err);
				});
		});

		return Observable.fromPromise(thePromise);
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/services/resolvers/all-grids.resolver.ts